"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAirportTransfer_ClientComplete = void 0;
const isAirportTransfer_ClientComplete = (details) => {
    if (!details)
        return false;
    if (details === null)
        return false;
    if (details.flight_number && details.flight_time) {
        return true;
    }
    return false;
};
exports.isAirportTransfer_ClientComplete = isAirportTransfer_ClientComplete;
